import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mb-4" }
const _hoisted_4 = { class: "row row-reference mb-4" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = {
  class: "btn-group btn-group-sm w-auto mb-3",
  role: "group",
  "aria-label": "Reference type"
}
const _hoisted_7 = { class: "row row-layout mb-4" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = { class: "row row-image mb-4" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = { class: "col-3" }
const _hoisted_14 = { class: "col-3" }
const _hoisted_15 = {
  key: 0,
  class: "row row-filters mb-4"
}
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = { class: "row row-order-by mb-4" }
const _hoisted_20 = { class: "col-12 order-selector" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add_circle", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "col-12 order-results" }
const _hoisted_25 = {
  key: 0,
  class: "fst-italic"
}
const _hoisted_26 = { class: "col-3" }
const _hoisted_27 = { class: "badge bg-light text-dark fs-6 d-flex justify-content-between w-100" }
const _hoisted_28 = { class: "col buttons" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "mas text-primary" }, "keyboard_arrow_up", -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "mas text-primary" }, "keyboard_arrow_down", -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "mas text-danger" }, "delete", -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "row row-pagination" }
const _hoisted_40 = { class: "col-3" }
const _hoisted_41 = { class: "col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !_ctx.isReady
    }, null, 8, ["spin"]),
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleReferenceType(_ctx.PageReferenceTypeEnum.INTERNAL))),
                      class: _normalizeClass(['btn btn-outline-primary', {'active': _ctx.referenceType === _ctx.PageReferenceTypeEnum.INTERNAL}]),
                      type: "button"
                    }, _toDisplayString(_ctx.$t('internal')), 3),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleReferenceType(_ctx.PageReferenceTypeEnum.EXTERNAL))),
                      class: _normalizeClass(['btn btn-outline-primary', {'active': _ctx.referenceType === _ctx.PageReferenceTypeEnum.EXTERNAL}]),
                      type: "button"
                    }, _toDisplayString(_ctx.$t('external')), 3)
                  ]),
                  (_ctx.referenceType === _ctx.PageReferenceTypeEnum.INTERNAL)
                    ? (_openBlock(), _createBlock(_component_InputSelect, {
                        key: 0,
                        modelValue: _ctx.contentBlock.page_type_code,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentBlock.page_type_code) = $event)),
                          _ctx.onChange
                        ],
                        options: _ctx.pageTypeOptions,
                        label: _ctx.$t('collection'),
                        name: "page_type_code",
                        selectText: _ctx.$t('selectText'),
                        rules: (_ctx.referenceType === _ctx.PageReferenceTypeEnum.INTERNAL) ? 'required' : '',
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "rules", "errors"]))
                    : (_ctx.referenceType === _ctx.PageReferenceTypeEnum.EXTERNAL)
                      ? (_openBlock(), _createBlock(_component_InputSelect, {
                          key: 1,
                          modelValue: _ctx.contentBlock.page_abstr_lib_code,
                          "onUpdate:modelValue": [
                            _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contentBlock.page_abstr_lib_code) = $event)),
                            _ctx.onChange
                          ],
                          options: _ctx.pageAbstractLibOptions,
                          label: _ctx.$t('library'),
                          name: "page_abstr_lib_code",
                          selectText: _ctx.$t('selectText'),
                          rules: (_ctx.referenceType === _ctx.PageReferenceTypeEnum.EXTERNAL) ? 'required' : '',
                          errors: _ctx.errors
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "rules", "errors"]))
                      : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.contentBlock.layout_code,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contentBlock.layout_code) = $event)),
                      _ctx.onChange
                    ],
                    options: _ctx.overviewPageLayoutOptions,
                    label: _ctx.$t('layout'),
                    name: "layout_code",
                    selectText: _ctx.$t('selectText'),
                    rules: "required",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "errors"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.contentBlock.visibility_code,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contentBlock.visibility_code) = $event)),
                      _ctx.onChange
                    ],
                    options: _ctx.visibilityOptions,
                    label: _ctx.$t('cms.visibleContent'),
                    name: "visibility_code",
                    selectText: _ctx.$t('selectText'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "errors"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Subtitle, {
                    help: _ctx.$t('cms.helpTextPageReferenceVisibility'),
                    "help-position": "left",
                    class: "mt-1"
                  }, null, 8, ["help"])
                ])
              ]),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('image')
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.contentBlock.image_fit_code,
                    "onUpdate:modelValue": [
                      _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contentBlock.image_fit_code) = $event)),
                      _ctx.onChange
                    ],
                    options: _ctx.imageFitOptions,
                    label: _ctx.$t('cms.fit'),
                    name: "image_fit_code",
                    selectText: _ctx.$t('selectText'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "errors"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.contentBlock.image_horizontal_position_code,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contentBlock.image_horizontal_position_code) = $event)),
                      _ctx.onChange
                    ],
                    options: _ctx.imageHorizontalPositionOptions,
                    label: _ctx.$t('cms.positionHorizontal'),
                    name: "image_horizontal_position_code",
                    selectText: _ctx.$t('selectText'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "errors"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.contentBlock.image_vertical_position_code,
                    "onUpdate:modelValue": [
                      _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contentBlock.image_vertical_position_code) = $event)),
                      _ctx.onChange
                    ],
                    options: _ctx.imageVerticalPositionOptions,
                    label: _ctx.$t('cms.positionVertical'),
                    name: "image_vertical_position_code",
                    selectText: _ctx.$t('selectText'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "errors"])
                ])
              ]),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('filters')
              }, null, 8, ["title"]),
              (_ctx.referenceType !== _ctx.PageReferenceTypeEnum.EXTERNAL)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_input_text, {
                        modelValue: _ctx.filterLabel,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterLabel) = $event)),
                          _ctx.onChange
                        ],
                        modelModifiers: { trim: true },
                        label: _ctx.$t('cms.filterByLabel'),
                        name: "filter_label",
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_InputCheckbox, {
                          modelValue: _ctx.useFilterShowOnHomepage,
                          "onUpdate:modelValue": [
                            _cache[10] || (_cache[10] = ($event: any) => ((_ctx.useFilterShowOnHomepage) = $event)),
                            _ctx.onChange
                          ],
                          label: _ctx.$t('cms.useFilterShowOnHomepage'),
                          name: "useFilterShowOnHomepage",
                          errors: _ctx.errors
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"]),
                        _createVNode(_component_InputCheckboxBoolean, {
                          modelValue: _ctx.contentBlock.filter_show_on_homepage,
                          "onUpdate:modelValue": [
                            _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contentBlock.filter_show_on_homepage) = $event)),
                            _ctx.onChange
                          ],
                          label: _ctx.$t('cms.showOnHomepage'),
                          name: "filter_show_on_homepage",
                          class: "ms-3",
                          disabled: !_ctx.useFilterShowOnHomepage,
                          errors: _ctx.errors
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled", "errors"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('sortWeight')
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.selectedOrderFilter.order_field_code,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedOrderFilter.order_field_code) = $event)),
                      options: _ctx.orderFieldOptions,
                      label: _ctx.$t('field'),
                      name: "order_field_code",
                      selectText: _ctx.$t('selectText'),
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "options", "label", "selectText", "errors"]),
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.selectedOrderFilter.order_direction_code,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedOrderFilter.order_direction_code) = $event)),
                      options: _ctx.orderDirectionOptions,
                      label: _ctx.$t('direction'),
                      name: "order_direction_code",
                      class: "ms-2",
                      selectText: _ctx.$t('selectText'),
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "options", "label", "selectText", "errors"]),
                    _createElementVNode("button", {
                      onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addOrderFilter && _ctx.addOrderFilter(...args)), ["prevent"])),
                      class: "btn btn-icon mb-3 ms-2"
                    }, _hoisted_23)
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (!_ctx.contentBlock?.order_by_fields.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$t('noContentFound')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.contentBlock?.order_by_fields.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.contentBlock.order_by_fields, (orderField, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "row order-result-item d-flex align-items-center"
                        }, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("span", null, _toDisplayString(orderField.order_field_code), 1),
                              _createElementVNode("span", null, _toDisplayString(orderField.order_direction_code), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("button", {
                                onClick: _withModifiers(($event: any) => (_ctx.moveOrderFilter(index, _ctx.MoveActionEnum.UP)), ["prevent"]),
                                class: "btn btn-icon btn-sm"
                              }, _hoisted_32, 8, _hoisted_30),
                              _createElementVNode("button", {
                                onClick: _withModifiers(($event: any) => (_ctx.moveOrderFilter(index, _ctx.MoveActionEnum.DOWN)), ["prevent"]),
                                class: "btn btn-icon btn-sm"
                              }, _hoisted_35, 8, _hoisted_33),
                              _createElementVNode("button", {
                                onClick: _withModifiers(($event: any) => (_ctx.deleteOrderFilter(index)), ["prevent"]),
                                class: "btn btn-icon btn-sm"
                              }, _hoisted_38, 8, _hoisted_36)
                            ])
                          ])
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('pagination')
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.contentBlock.limit_references_count,
                    "onUpdate:modelValue": [
                      _cache[15] || (_cache[15] = ($event: any) => ((_ctx.contentBlock.limit_references_count) = $event)),
                      _ctx.onChange
                    ],
                    label: _ctx.$t('cms.maxNumberReferences'),
                    name: "limit_references_count",
                    "can-clear": "",
                    min: 0,
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.contentBlock.references_per_page,
                    "onUpdate:modelValue": [
                      _cache[16] || (_cache[16] = ($event: any) => ((_ctx.contentBlock.references_per_page) = $event)),
                      _ctx.onChange
                    ],
                    label: _ctx.$t('cms.numberReferencesPerPage'),
                    name: "references_per_page",
                    "can-clear": "",
                    min: 0,
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}